import Vue from 'vue'
import fn from "../../helpers/func";
import _ from 'lodash';

export default {
  getPagedContent: async function (context, params) {
    /// params::::
    // id: menu id;
    // place: primary or one of secondary place name;
    // page: selected page id;
    // terms: selected terms ids array;
    // search: searched word

    /// request for content
    let res = await fn.postData('main/getDataList', params);

    if (res.status != 200) {
      Vue.set(context.state, 'current_content_request_status', 'error');
      return false;
    }

    if(!_.get(res, 'data.componentUnicId')){
      console.log('unic id not set');
      return false;
    }

// console.log(_.get(res, 'data.componentUnicId'), context.state.current_content.secondary);

    // console.log(context.state.current_content);
    /// set paged content to primary
    /// set paged content to component

    for (let i in context.state.current_content.secondary){
      if(_.get(context.state.current_content.secondary[i], 'conf.unicId') === _.get(res, 'data.componentUnicId')){
        Vue.set(context.state.current_content.secondary[i].data, 'list', res.data.list);
        Vue.set(context.state.current_content.secondary[i].data, 'listCount', res.data.listCount);
        break;
      }
    }


  },

  //// get comparable products
  getComparables: async function (context, params) {
    /// params::::
    // id: product ids;

    if( _.get(context.state.cache, 'comparable_'+context.state.breadcrumbsLeveled.lvl2) )return false;
    /// request for content
    let res = await fn.postData('main/getComparables', params);

    if (res.status != 200) {
      return false;
    }
    Vue.set(context.state.cache, 'comparable_'+context.state.breadcrumbsLeveled.lvl2, res.data);

  },

  getCurrentContent: async function (context, params) {

    /// check content id. if false leave empty content
    if (!params || !params.id) {
      return false;
    }

    let request = { contentid: params.id, selectedlan: context.state.locale };
    if (params.routeParams) {
      for (let i in params.routeParams) {
        request[i] = params.routeParams[i];
      }
    }

    let current_content_last_request = JSON.stringify(request);
    if(current_content_last_request == context.state.current_content_last_request)return false;

    Vue.set(context.state, 'current_content_last_request', current_content_last_request);
    Vue.set(context.state, 'current_content_request_status', 'pending');

    /// request for content
    let res = await fn.postData('main/getCurrentContent', request);
// console.log(res);
    /// if response failed leave empty content and return false
    if (res.status != 200) {
      Vue.set(context.state, 'current_content', {});
      Vue.set(context.state, 'current_content_request_status', 'error');

      return false;
    }

    // Vue.set(context.state, 'current_content_request_status', 'changing');

    /// if success response set content
    Vue.set(context.state, 'current_content', res.data);
// console.log(context.state.current_content_request_status);
    Vue.set(context.state, 'current_content_request_status', 'done');

  },

  getCurrentContentProto: async function (context, params) {

    /// check content id. if false leave empty content
    if (!params || !params.id) {
      return false;
    }

    let request = { contentid: params.id, selectedlan: context.state.locale };
    if (params.routeParams) {
      for (let i in params.routeParams) {
        request[i] = params.routeParams[i];
      }
    }

    let current_content_last_request = JSON.stringify(request);

    if(current_content_last_request == context.state.current_content_last_request)return false;

    Vue.set(context.state, 'current_content_last_request', current_content_last_request);
    Vue.set(context.state, 'current_content_request_status', 'pending');

    /// request for content
    let res = await fn.postData('main/getCurrentContent', request);
// console.log(res);

    /// if response failed leave empty content and return false
    if (res.status != 200) {
      Vue.set(context.state, 'current_content', {});
      Vue.set(context.state, 'current_content_request_status', 'error');

      return false;
    }

    // Vue.set(context.state, 'current_content_request_status', 'changing');

    /// if success response set content
    Vue.set(context.state, 'current_content_buffer', res.data);
// console.log(context.state.current_content_request_status);
    Vue.set(context.state, 'current_content_request_status', 'done');

  },

  getTranslations: async function (context) {
    if(context.state.translations)return false;
    let tmp = await fn.postData('main/getTranslations');
    if (tmp.status != 200) return false;
    context.state.translations = tmp.data;
  },

  getServiceCenters: async function (context) {
    if(_.size(context.state.serviceCenters))return false;
    let tmp = await fn.postData('main/getServiceCenters');
    if (tmp.status != 200) return false;
    context.state.serviceCenters = tmp.data;
  },

  getServiceMap: async function (context) {
    if(_.size(context.state.serviceMap))return false;
    let tmp = await fn.postData('main/getServiceMap');
    if (tmp.status != 200) return false;
    context.state.serviceMap = tmp.data;
  },

  /** get bulk data by node
 * params.node */
  getBulkData: async function (context, params){
    if(!_.get(params, 'key'))return false;

    if(_.size(_.get(context.state, [ 'cache', params.key ])) && !_.get(params, 'force'))return false;

    let tmp = await fn.postData('main/getBulkData', params);
    if (tmp.status != 200) return false;

    Vue.set(context.state.cache, params.key, tmp.data);

  },

  indx: async function (context) {

    let tmp = await fn.postData('main/indx');
    if (tmp.status != 200) return false;
    context.state.indx = tmp.data;

    if(!_.get(context.state.indx.locales, context.state.locale)){
      context.state.locale = _.get(tmp.data, 'locale');
    }
    context.commit('setMenuFullUrls');
  },

  indxTranslatable: async function (context) {

    let tmp = await fn.postData('main/indxTranslatable');
    if (tmp.status != 200) return false;
    // context.state.indx = tmp.data;

    for (let i in tmp.data){
      Vue.set(context.state.indx, i, tmp.data[i]);
    }

  },

}
